import { Injectable } from '@angular/core';
import { Socket } from 'ngx-socket-io';
import { BoxMessage } from '../models/boxmessage';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';
import { LocalSession } from '../providers/local-session.provider';

@Injectable({
  providedIn: 'root'
})

export class BoxService {

	private _status :any;
	private _id :string = '1';

	constructor(private socket: Socket,
		private router: Router,
		protected localSession: LocalSession) { 
	}

	public viewVideo():void{
		// var msg = new BoxMessage(this._id, 'video', {url: '/home/pi/Downloads/file_example_MOV_1280_1_4MB.mov'});
		var msg = new BoxMessage(this._id, 'video', {url: '/home/pi/Downloads/SampleVideo_720x480_10mb.mp4'});
		this.sendMessage(msg);
	}

	public getDeviceInfo():void{
		var msg = new BoxMessage(this._id, 'get_info');

		this.sendMessage(msg);
	}

	public gotoSantizationScreen():void{
		var msg = new BoxMessage(this._id, 'goto', {url: 'sanitization'});

		this.sendMessage(msg);
	}

	public gotoIdleScreen():void{
		var msg = new BoxMessage(this._id, 'goto', {url: 'idle'});

		this.sendMessage(msg);
	}

	public gotoBlackScreen():void{
		var msg = new BoxMessage(this._id, 'goto', {url: 'black'});

		this.sendMessage(msg);
	}

	public gotoReadyScreen():void{
		var msg = new BoxMessage(this._id, 'goto', {url: 'ready'});

		this.sendMessage(msg);
	}

	public open():void{
		var msg = new BoxMessage(this._id, 'open');

		this.sendMessage(msg);
	}

	public close():void{
		var msg = new BoxMessage(this._id, 'close');
		msg.action = 'close';

		this.sendMessage(msg);
	}

	public openBackDoor():void{
		var msg = new BoxMessage(this._id, 'open_back_door');

		this.sendMessage(msg);
	}

	public forceStop():void{
		var msg = new BoxMessage(this._id, 'force_stop');

		this.sendMessage(msg);
	}

	public updateStatus(){
		var msg = new BoxMessage(this._id, 'status');

		this.sendMessage(msg);

		return this._status;
	}

	public setActualPage(page){
		var msg = new BoxMessage(this._id,'actual_page',page);

		this.sendMessage(msg);
	}

	public setOrderDone(){
		var msg = new BoxMessage(this._id,'order','deliver');

		this.sendMessage(msg);
	}

	public answerPoll(hash_id:any, pollName:string, pollAnswer:string = ""){
		var msg = new BoxMessage(this._id,'poll_answer', {'hash_id': hash_id, 'poll_name': pollName, 'poll_answer': pollAnswer});

		this.sendMessage(msg);
	}

	public sendMessage(message: BoxMessage) {
    	this.socket.emit('fos:box', message);
	}

	public getStatus(): any{
		return this._status;
	}

	public getMessagesStatus = () => {
	    return Observable.create((observer) => {
	            this.socket.on('fos:box', (msg: BoxMessage) => {
	            	// console.log(msg);
	            	
	            	switch(msg.action){
	            		case 'status':
	            			this._status = JSON.parse(msg.message);
	            			break;
	            	}
	            	
	                observer.next(msg);
	            });

	            this.socket.on('connect', (data: any) => {
	            	this.localSession.setSocketConnected(true);
	            	
	                observer.next(data);
	            });

	            this.socket.on('disconnect', (data: any) => {
	            	this.localSession.setSocketConnected(false);
	            	
	                observer.next(data);
	            });
	    });
	}

	public getMessages = () => {
	    return Observable.create((observer) => {
	            this.socket.on('fos:box', (msg: BoxMessage) => {
	            	console.log(msg);
	            	
	            	switch(msg.action){
	            		case 'device_info':
	            			this.localSession.setDeviceInfo(msg.data);
	            			break;

	            		case 'goto':
	            			this.localSession.setOrder(msg.data);
	            			this.gotoUrl(msg.params.url);
	            			break;

	            		case 'obstructed':
	            			this.router.navigate(['/Obstructed']);
	            			break;

	            		case 'poll':
	            			this.localSession.setPoll(msg.data);
	            			break;

	            		case 'opening':
	            		case 'closing':
	            			this.router.navigate(['/InfoPedidoComponent']);
    						break;
	            	}
	            	
	                observer.next(msg);
	            });

	            this.socket.on('connect', (data: any) => {
	            	this.localSession.setSocketConnected(true);
	            	
	                observer.next(data);
	            });

	            this.socket.on('disconnect', (data: any) => {
	            	this.localSession.setSocketConnected(false);
	            	this.router.navigate(['/Error']);
	            	
	                observer.next(data);
	            });
	    });
	}

	private gotoUrl(url){
		switch(url){
    		case 'black':
    			this.router.navigate(['/BlackTLCDComponent']);
    			break;
    		case 'ready':
    			this.router.navigate(['/OpenBox']);
    			break;
    		case 'obstructed':
    			this.router.navigate(['/Obstructed']);
    			break;
    		case 'sanitization':
    			this.router.navigate(['/Sanitization']);
    			break;
    		case 'thanks':
    			this.router.navigate(['/ThanksStateComponent']);
    			break;
    		// case 'thanks-demo':
    			// this.router.navigate(['/Demo/Thanks']);
    			// break;
			case 'box_opened':
			case 'box_closed':
    		case 'idle':
    		default:
    			this.router.navigate(['/IdleStateComponent']);
    			break;
    	}
	}

}
